import { render, staticRenderFns } from "./EmployerInvestmentSettings.vue?vue&type=template&id=20979389"
import script from "./EmployerInvestmentSettings.vue?vue&type=script&lang=ts"
export * from "./EmployerInvestmentSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports